var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{staticClass:"cashierdiary--inpout",attrs:{"placeholder":_vm.inputTip,"value-format":"yyyy-MM-dd","type":"date"},model:{value:(_vm.editInput),callback:function ($$v) {_vm.editInput=$$v},expression:"editInput"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebd39e2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/components/cashierdiaryTable/attr/c-date.vue
// module id = null
// module chunks = 